import styled from 'styled-components';
import { device } from '../../../util/commonMediaStylesUtil';

export const SidebarWrapper = styled.div`
  // height: 100vh;
  height: 100%;
  overflow-y: auto;
  max-width: 480px;
  background-color: #3a3a4a;
  border-color: #000000;
  border-style: solid;
  border-width: 1px;
  padding: 20px;

  @media (max-width: 1170px) {
    max-width: 100%;
    border-color: #3a3a4a;
    border-style: none;
  }
  @media (max-width: 992px) {
    padding: 20px 10px;
  }
`;

export const SidebarContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
`;

export const SidebarCollapsedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-item: center;
  width: 80px;
`;

export const SidebarExpandedContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-item: center;
`;
export const SidebarWarningContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
`;

export const SidebarWarningIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SidebarWarningText = styled.div`
  font-family: EYInterstate;
  font-size: 14px;
  font-weight: 300;
  color:#ffffff;
`;

export const SidebarTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
  // width: 241px;
  color: #ffffff;
  font-family: 'EYInterstate';
`;

// SidebarStyles.js
export const SidebarQuarterlyContainer = styled.button`
  max-width: 430px;
  width: 100%;
  height: 60px;
  // background: linear-gradient(#23232f, #23232f) 0px 0px / 100% 60px no-repeat,
  //   linear-gradient(#2e2e3c, #2e2e3c) 0px 60px / 100% 100% no-repeat;
  background-color: #2e2e3c;
  transition: background 0.3s;
  overflow: hidden;
  border: 0px;

  &.expanded {
    height: auto;
    // height: 409px;
    // background: linear-gradient(#23232f, #23232f) 0px 0px / 100% 60px no-repeat,
    //   linear-gradient(#2e2e3c, #2e2e3c) 0px 60px / 100% 100% no-repeat;
    background-color: #2e2e3c;
  }

  &.focusContainer {
    border: 1px solid #fff;
  }

  @media (max-width: 1170px) {
    max-width: 100%;
    width: 100%;
  }
`;

export const AccordionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  color: #ffffff;
  font-family: 'EYInterstate';
  padding: 15px;
`;

export const QuarterHeaderTitle = styled.h3``;

export const QuarterHeaderCollapseTitle = styled.h3`
  border-top: 2px solid grey;
  color: #ffffff;
  padding: 10px 0px 0px 0px;
`;

export const AccordionTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  color: #ffffff;
  font-family: 'EYInterstate Light';
  padding: 15px;
`;

export const WonAccordianValue = styled.span`
  padding: 0px 0px 0px 10px;
`;

export const ChevronIcon = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
  transform: rotate(0deg);
  transition: transform 0.3s;

  &.expanded {
    transform: rotate(180deg);
  }
`;

export const AccordionContent = styled.div`
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  color: #ffffff;
`;

export const AccordionCollpaseContent = styled.div`
  padding-top: 10px;
  color: #ffffff;
`;

export const AccordionContentFuture = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: 'EYInterstate Regular';
  font-size: 22px;
  line-height: 22px;
  text-align: center;

  img {
    height: 47px;
    width: 14px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;
export const AccordionContentDashboard = styled(AccordionContentFuture)`
  color: #1a1a24;
`;

export const AccordionText = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-family: 'EYInterstate';
  text-align: left;
`;

// CrmChartStyles.js
export const CrmChartQuarterlyContainer = styled.div`
  max-width: 430px;
  height: 47px;
  border: 0px 0px 1px 0px;
  gap: 2px;
  display: flex;
  align-items: flex-end;
  align-self: stretch;
  margin-bottom: 10px;
  position: relative;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const CrmChartQuarterlyBar = styled.div`
  // max-width: 381px;
  height: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;

  @media (max-width: 768px) {
    max-width: 100%; /* Modify styles for smaller screens */
  }
`;

export const Bar = styled.div`
  // border: 1px solid #747480;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const GapBar = styled.div`
  // border: 1px solid #747480;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #f6f6fa;
  background: repeating-linear-gradient(
    -45deg,
    transparent,
    transparent 3.4px,
    rgb(116, 116, 128) 3.8px,
    rgb(116, 116, 128) 4.5px
  );
  border: 1px solid #747480;
  // background: repeating-linear-gradient(-45deg, #2e2e3c, #2e2e3c 1px, #747480 2px, #747480 4px);
`;

export const GapBarDashboard = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #f6f6fa;
  background: repeating-linear-gradient(
    -45deg,
    transparent,
    transparent 3.4px,
    rgb(116, 116, 128) 3.8px,
    rgb(116, 116, 128) 4.5px
  );
  border: 1px solid #e1e1e6;
`;

// LegendStyles.js
export const LegendContainer = styled.div`
  width: 348px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  margin-bottom: 10px;

  ${device.phone_l`
    width: auto;
    padding-right: 10px;
`}
`;

export const LegendCollapsContainer = styled.div``;

export const LabelStyle = styled.div`
  font-family: 'EYInterstate Regular';
  font-size: 22px;
  line-height: 22px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: self-start;
  padding: 5px;
`;

export const LabelCollapsedStyle = styled.div`
  font-family: 'EYInterstate Regular';
  font-size: 22px;
  line-height: 22px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: self-start;
  padding: 5px 5px 20px 5px;
`;

export const GapColorStyle = styled.div`
  width: 10px;
  height: 10px;
  background: repeating-linear-gradient(
    -45deg,
    transparent,
    transparent 3.4px,
    rgb(116, 116, 128) 3.8px,
    rgb(116, 116, 128) 4.5px
  );
  border: 1px solid rgb(116, 116, 128);
  // border: 1px solid #747480;
  // background: repeating-linear-gradient(-45deg, #2e2e3c, #2e2e3c 2px, #747480 1px, #747480 3px);
`;
export const GreenColorStyle = styled.div`
  width: 10px;
  height: 10px;
  background-color: #189d3e;
`;

export const OrangeColorStyle = styled.div`
  width: 10px;
  height: 10px;
  background-color: #ff9831;
`;

export const LegendTextStyle = styled.span`
  font-family: 'EYInterstate';
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  padding-left: 5px;
`;

export const LegendTextCollapsStyle = styled.span`
  font-family: 'EYInterstate';
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
`;

export const RowStyle = styled.div`
  font-family: 'EYInterstate Regular';
  font-size: 22px;
  line-height: 22px;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FlagImage = styled.img`
  width: 10px;
  height: 10px;
`;

// MonthlySidebarStyles.js
export const MonthlyBar = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const SidebarStyle = styled.div`
  height: 50px;
  // width: 430px;
  display: flex;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
  border: ${props => (props.setBorader ? '1px solid #ffff00' : '0px solid #ffff00')};

  @media (max-width: 1170px) {
    width: 100%;
  }
`;

export const SidebarMonthText = styled.p`
  color: #c4c4cd;
  font-family: 'EYInterstate';
  margin-right: 15px;
  width: 25px;

  &.beyond-text-only {
    width: 100px;
  }
`;

export const ColumnStyle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  color: #ffffff;
  font-family: 'EYInterstate Regular';
  font-size: 14px;
  padding: 5px;
`;

export const ColumnOneStyle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: #ffffff;
  font-family: 'EYInterstate Regular';
  font-size: 14px;
  padding: 5px;
`;

export const SoldTextStyle = styled.span`
  color: #c4c4cd;
  font-family: 'EYInterstate';
  font-size: 14px;
  line-height: 22px;
  padding-left: 5px;
`;

export const GreenHashBar = styled.div`
  background: repeating-linear-gradient(
    -45deg,
    #189d3e,
    #189d3e 1px,
    rgba(0, 0, 0, 0.38) 3px,
    rgba(0, 0, 0, 0.38) 4px
  );
  // border: 1px solid #189d3e;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const OrangeHashBar = styled.div`
  background: repeating-linear-gradient(
    -45deg,
    #ff9831,
    #ff9831 1px,
    rgba(0, 0, 0, 0.38) 3px,
    rgba(0, 0, 0, 0.38) 4px
  );
  // border: 1px solid #ff9831;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const MissedText = styled.span`
  color: #b9251c;
  font-family: 'EYInterstate';
`;
